import React from "react";

import useFeaturesColorMatch from "../useFeaturesColorMatch";
import {QKB_ANALYTIC_EVENTS} from "../../../../analytics";
import LookFeatureColorMatchCheckbox
  from "../../../look/lookNavigation/lookMain/lookFeature/lookFeatureColorMatchCheckbox";
import LoadingSpinner from "../../../ui/loadingSpinner";
import {COUNTERTOP_GROUP_BATHROOM} from "../../../look/core/constants";

export default function BodyPanelColorMatch(props) {

  const {featureGroup} = props;

  const {sameColorFeatures, currentColorFeatures, isLoading} = useFeaturesColorMatch(featureGroup);

  if (featureGroup?.partId && COUNTERTOP_GROUP_BATHROOM.includes(featureGroup.partId)) {
    return null
  }

  if (isLoading) {
    return <LoadingSpinner size="no-size" style={{
      width: "20px",
      height: "20px",
      display: "inline-block",
      verticalAlign: "middle",
      backgroundSize: "100%",
      marginLeft: "15px",
    }}/>
  }

  return <LookFeatureColorMatchCheckbox currentColorFeatures={currentColorFeatures}
                                        sameColorFeatures={sameColorFeatures}
                                        forFeature={featureGroup?.activeFeature}
                                        checkboxText={"look.allCountertops"}
                                        analyticsLabel={QKB_ANALYTIC_EVENTS.bodyPanelMatchAll}/>
}
